import { jsxs as t, jsx as r } from "react/jsx-runtime";
import { CreateLabel as a } from "./style.es.js";
import { Typography as i } from "../../../Typography/Typography.es.js";
import { Button as m } from "../../Button/Button.es.js";
import { Icon as n } from "../../../DataDisplay/Icon/Icon.es.js";
function f({
  value: e,
  createNewText: o
}) {
  return /* @__PURE__ */ t(a, { children: [
    /* @__PURE__ */ r(i, { variant: "body2", children: o }),
    /* @__PURE__ */ r(m, { size: "sm", variant: "link", startIcon: /* @__PURE__ */ r(n, { name: "add", size: "sm" }), children: e })
  ] });
}
export {
  f as CreateLabel
};
//# sourceMappingURL=CreateLabel.es.js.map
